import { L1AllowList } from "@turnstile-portal/turnstile.js";
import type { Address } from "viem";
import { getL1AllowListAddr } from "../lib/addresses.js";
import { getL1ClientAsync } from "../wagmi.js";

export async function acceptToken(tokenAddress: Address) {
  try {
    const l1Client = await getL1ClientAsync();
    const allowList = new L1AllowList(getL1AllowListAddr(), l1Client);

    // Accept the token to the allowlist using the connected wallet
    const receipt = await allowList.accept(tokenAddress, l1Client);
    console.log(`Accepted proposal in tx ${receipt.transactionHash}`);
  } catch (error) {
    console.error("Error accepting token:", error);
    // Re-throw the error so the calling code can handle it
    throw error;
  }
}
